// Shared subscription/plan cache-key factory (P18 §4, story 2-73). Not backed
// by a generated `*.gen.ts` factory because `/subscriptions/:orgId` and
// `/subscriptions/plans` have no zod contract under `contracts/` yet — they
// are pre-existing, hand-rolled endpoints in `lib/apiClient.ts` predating
// story 2-92's contract-first generator. This hand-follows the SAME factory
// shape (`all` / a keyed accessor) `sync-contracts.mjs` would emit, so it
// reads like every generated module even though nothing generates it.
//
// Lives in `lib/query/`, not `modules/billing/queries/keys.ts`, because the
// subscription doc is read across module boundaries: Sidebar's plan card,
// `DashboardPage`, the public `PricingPage`, and the billing module's own
// `BillingPage` all read the SAME cache entry. P18 §1's module-isolation
// eslint rule (`no-restricted-imports`, `**/modules/*/**`) forbids
// `src/hooks/useSubscription.ts` or `src/pages/PricingPage.tsx` importing
// anything under `src/modules/billing/` — so a module-private key factory
// can never be the single source every one of those needs. This is the same
// "shared paywall/usage-meter components stay in components/billing/ because
// other features consume them" carve-out the billing module's own manifest
// (`modules/billing/index.ts`) documents for components; the same reasoning
// applies to this cache namespace. `modules/billing/queries/keys.ts`
// re-exports this instead of declaring its own competing literal — that
// duplication (one hand-rolled copy in the module, one inline at every OTHER
// call site) is the exact 2-32/2-54 drift this story closes.
export const subscriptionKeys = {
  all: ['subscription'] as const,
  /** The one org's subscription doc — every consumer of `GET /subscriptions/:orgId`. */
  detail: (orgId: string | undefined) => [...subscriptionKeys.all, orgId] as const,
  /** The public plan catalog — `GET /subscriptions/plans`. */
  plans: () => [...subscriptionKeys.all, 'plans'] as const,
};
